import { ArrowLeft, ChevronDown } from "lucide-react";
import React from "react";
import AgentInfo from "./agentInfosection/AgentInfo";
import PropertyGrids from "./PropertGrids/PropertyGrids";
import PropertyHero from "./PropertyHeroSearch/PropertyHero";
import MyNavbar from "components/Buyer/navbar/MyNavbar";
import Footer from "components/Buyer/footer/Footer";
const Properties=()=>{
    return(
        <>
        <MyNavbar type="nosticky"/>
        {/* <PropertyHero/> */}
        <PropertyGrids/>
        <AgentInfo/>
        <Footer/>
        </>
    )
}
export default Properties;